import { useFormik, Form, FormikProvider } from "formik";
import { Button } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import { createDocument } from "apis/customApiHandler";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";

const AddAlignmentCenter = ({ handleClick }) => {
  const queryClient = useQueryClient();
  const formik = useFormik({
    initialValues: {
      name: "",
    },
    onSubmit: async (values) => {
      const data = await createDocument("alignment-center", values);
      if (data) {
        toast.success("Successfully saved");
        queryClient.invalidateQueries("alignment-center");
      }
      handleClick();
    },

    validate: (values) => {
      let errors = {};
      if (!values.name) errors.name = "Required";
      return errors;
    },
  });

  return (
    <Model
      handleClick={handleClick}
      title={"Add Alignment Center"}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base grid  lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full">
          <InputField type="text" label="Alignment Center Name" name="name" />
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" bgPrimary onClick={formik.handleSubmit}>
            Save Changes
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

export default AddAlignmentCenter;
